var map = {
	"./AICS Logo.png": 9680,
	"./CONI_Positivo4.jpg": 6757,
	"./Logo Pole Revolution Italy.png": 5421,
	"./csit (3).png": 6423,
	"./logo-POSA-Arts-World-Federation.jpg": 5534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4619;